import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { CollaborativeAgreementSigned } from './collaborativeAgreements';


export type CollaborativePhysicianMatch = {
  id: string;
  collaborativePhysicianId: string;
  providerId: string;
  stateId: string;
};


export type CollaborativePhysicianActivationStatus = 'pending_invite' | 'invite_sent' | 'onboarding' | 'ready_to_go' | 'live' | 'deactivated';


export type CollaborativePhysicianStateSeats = {
  stateId: string;
  seatsUsed: number;
  seatCapacity: number | null;
};


export type CollaborativePhysician = {
  providerId: string;
  supportedStateIds: string[];
  firstName: string;
  lastName: string;
  email: string;
  activationStatus: CollaborativePhysicianActivationStatus | null;
  licensedStateIds: string[];
  stateSeats: CollaborativePhysicianStateSeats[];
};


export const getAllCollaborativePhysicians = () => restClient.request<{
  data: CollaborativePhysician[];
}>('/api/v1/admin/collaborative_physician/physicians');

export const getCollaborativePhysician = (providerId: string) => restClient.request<{
  data: CollaborativePhysician | null;
}>(`/api/v1/admin/collaborative_physician/physicians/${providerId}`);

export const setPhysicianCollaborationAvailable = (licenseId: string, available: boolean) => restClient.request(
  `/api/v1/admin/collaborative_physician/license/${licenseId}/collaboration_available`, {
    method: 'POST',
    data: {
      available,
    },
  }
);


export const getCollaborativePhysicianMatch = (matchId: string) => restClient.request<{
  data: CollaborativePhysicianMatch;
}>(`/api/v1/admin/collaborative_physician/match/${matchId}`);


export const getCollaborativePhysicianMatchesForPhysician = (collaborativePhysicianId: string) => restClient.request<{ data: CollaborativePhysicianMatch[] }>(
  `/api/v1/physician/${collaborativePhysicianId}/collaborative_physician/matches`
);


export const getCollaborativeMatchesForPhysicianAndProvider = (physicianId: string, providerId: string) => restClient.request<{ data: CollaborativePhysicianMatch[] }>(
  `/api/v1/physician/${physicianId}/${providerId}/matches`
);

export const getCollaborativePhysicianMatchesForProvider = (providerId: string) => restClient.request<{ data: CollaborativePhysicianMatch[] }>(
  `/api/v1/provider/${providerId}/collaborative_physician/matches`
);

export type CreateCollaborativePhysicianParams = Omit<CollaborativePhysicianMatch, 'id'>;
export const createCollaborativePhysicianMatch = (params: CreateCollaborativePhysicianParams) => restClient.request<{ data: CollaborativePhysicianMatch[] }>(
  '/api/v1/admin/collaborative_physician/match', {
    method: 'POST',
    data: snakecaseKeys(params),
  }
);


export type DeleteCollaborativePhysicianParams = Pick<CollaborativePhysicianMatch, 'providerId' | 'stateId'>;
export const deleteCollaborativePhysicianMatch = (params: DeleteCollaborativePhysicianParams) => restClient.request<{ data: CollaborativePhysicianMatch[] }>(
  '/api/v1/admin/collaborative_physician/match', {
    method: 'DELETE',
    data: snakecaseKeys(params),
  }
);


export const getCollaborativePhysicianMatchAgreement = (matchId: string) => restClient.request<{ data: CollaborativeAgreementSigned }>(
  `/api/v1/admin/collaborative_physician/match/${matchId}/agreement`
);
